import commonStyles from "./common";
const styles = {
  title: {
    ...commonStyles.headerTitleWithUnderline,
    textAlign: "center",
    fontWeight: "heavy",
    fontSize: 13,
    textDecoration: "underline",
    paddingTop: 20
  },
  tableLayout: {
    ...commonStyles.table,
    margin: "20 auto 40 50",
    width: "80%"
  },
  tableKeyCol: {
    ...commonStyles.tableCol,
    width: "40%",
    paddingLeft: 10,
    fontWeight: "heavy"
  },
  tableValueCol: {
    ...commonStyles.tableCol,
    width: "60%",
    paddingLeft: 5
  },
  tableCell: {
    fontSize: 10,
    padding: 3,
    paddingTop: 5
  }
};

export default styles;
